export default "__VITE_ASSET__75uukILR__"